import { render, staticRenderFns } from "./CreateResetPassword.vue?vue&type=template&id=2e6c00af&scoped=true&"
import script from "./CreateResetPassword.vue?vue&type=script&lang=js&"
export * from "./CreateResetPassword.vue?vue&type=script&lang=js&"
import style0 from "./CreateResetPassword.vue?vue&type=style&index=0&id=2e6c00af&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e6c00af",
  null
  
)

export default component.exports